<p-drawer [(visible)]="appModalVisible" position="right" [modal]="true" 
    [closeOnEscape]="!loading" [blockScroll]="true" (onHide)="closeModal()"
    [style]="{ width: '380px' }" [closable]="true">

    <!-- Header -->
    <ng-template pTemplate="header">
        <h2 class="header">{{ modalHeader }}</h2>
    </ng-template>

    <!-- Content -->
    <div class="filters-container">
        <form [formGroup]="profileForm" class="filter-form">

            <!-- First Name -->
            <div class="field mb-4">
                <label class="form-label">
                    First Name <span class="text-red-600">*</span>
                </label>
                <input pInputText formControlName="first_name" class="w-full" [disabled]="loading" 
                    placeholder="Enter your first name" />
                <small *ngIf="isInvalid('first_name')" class="p-error">
                    First name is required
                </small>
            </div>

            <!-- Last Name -->
            <div class="field mb-4">
                <label class="form-label">
                    Last Name <span class="text-red-600">*</span>
                </label>
                <input pInputText formControlName="last_name" class="w-full" [disabled]="loading" 
                    placeholder="Enter your last name" />
                <small *ngIf="isInvalid('last_name')" class="p-error">
                    Last name is required
                </small>
            </div>

            <!-- Work Email -->
            <div class="field mb-4">
                <label class="form-label">
                    Work Email <span class="text-red-600">*</span>
                </label>
                <input pInputText formControlName="email" class="w-full" [disabled]="true" />
            </div>

            <!-- Phone Number -->
            <!-- <div class="field mb-4">
                <label class="form-label">
                    Phone Number <span class="text-red-600"></span>
                </label>
                <input pInputText formControlName="phone_number" class="w-full" [disabled]="loading" 
                    placeholder="Enter your phone number" />
                <small *ngIf="isInvalid('phone_number')" class="p-error">
                    Phone number is required
                </small>
            </div> -->

        </form>

        <!-- Footer Buttons -->
        <div class="filter-header mt-4 flex justify-end gap-2">
            <button pButton type="button" label="Cancel" class="p-button-outlined" (click)="closeModal()"
                [disabled]="loading">
            </button>

            <button pButton type="button" (click)="updateProfile()" label="Update" class="gradient-bg"
                [disabled]="loading || profileForm.invalid">
            </button>
        </div>

    </div>
</p-drawer>